import * as curl from './curl';
import * as java from './java';
import * as python from './python';
import * as pythonSDK from './pythonSDK';
import * as nodejs from './nodejs';
import * as nodejs_SDK from './nodejsSDK';
import { Language, WorkflowSnippets } from '../types';

export const workflowSnippets: WorkflowSnippets = {
  [Language.Java]: java,
  [Language.cURL]: curl,
  [Language.Python]: python,
  [Language.PythonSDK]: pythonSDK,
  [Language.NodeJS]: nodejs,
  [Language.NodeJS_SDK]: nodejs_SDK,
};
